import Dialog from "material-ui/Dialog";

import StyledModalConfirmacaoExecucao from "./styledModalConfirmacaoExecucaoIntegracao";
import intl from 'react-intl-universal'
import PropTypes from 'prop-types'
import Button from "components/button";

const ModalConfirmacaoExecucaoIntegracao = ({ showModalConfirmation, handleShowModal, executeAndCloseModal, descricaoIntegracao, desabilitarBotaoOk, avisoProximaExecucaoMinutos, children }) => (
  <Dialog open={showModalConfirmation} contentStyle={{ width: "600px" }} title={descricaoIntegracao}>
    <StyledModalConfirmacaoExecucao>
      <div>{children}</div>

      {avisoProximaExecucaoMinutos != null && (
        <div className="aviso-proxima-execucao">
          ⚠️{' '}
          {avisoProximaExecucaoMinutos === 0
            ? intl.get('master-data.configurations.integrations.scheduledInLessThanMinute') || 'Esta integração está agendada para executar em menos de 1 minuto. Deseja executar agora mesmo assim?'
            : (intl.get('master-data.configurations.integrations.scheduledInMinutes', { minutes: avisoProximaExecucaoMinutos }) || `Esta integração está agendada para executar em ${avisoProximaExecucaoMinutos} minuto(s). Deseja executar agora mesmo assim?`)
          }
        </div>
      )}

      <div className="mensagem-modal-integracao-mensagem">{intl.get('master-data.configurations.integrations.header.message')}</div>

      <div className="divisor-modal-integracao" />

      <div className="botoes-modal-integracao">
        <Button
          value={intl.get('geral.buttonsDefault.cancel')}
          onClick={handleShowModal}
          className="btn"
          style={{ width: "150px" }}
        />
        <Button
          buttonType="primary"
          value="OK"
          onClick={executeAndCloseModal}
          className="btn margin-botao"
          disabled={desabilitarBotaoOk}
          style={{ width: "150px" }}
        />
      </div>
    </StyledModalConfirmacaoExecucao>
  </Dialog>
);

ModalConfirmacaoExecucaoIntegracao.propTypes = {
  showModalConfirmation: PropTypes.bool.isRequired,
  handleShowModal: PropTypes.func.isRequired,
  executeAndCloseModal: PropTypes.func.isRequired,
  descricaoIntegracao: PropTypes.string.isRequired,
  desabilitarBotaoOk: PropTypes.bool.isRequired,
  avisoProximaExecucaoMinutos: PropTypes.number,
  children: PropTypes.node
};

export default ModalConfirmacaoExecucaoIntegracao;
